import React from 'react'

const AILabelNewIcon = ({ style }: { style?: React.CSSProperties }) => {
    return (
        <>
            <svg
                style={{ animation: 'rotate 2s linear infinite', ...style }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                {/* Background circle */}
                <circle cx="12" cy="12" r="8" stroke="#E5E7EB" strokeWidth="2.4" fill="none" />
                {/* Solid color arc */}
                <path
                    d="M12 4C13.5823 4 15.129 4.46919 16.4446 5.34824C17.7602 6.22729 18.7855 7.47672 19.391 8.93853C19.9965 10.4003 20.155 12.0089 19.8463 13.5607C19.5376 15.1126 18.7757 16.538 17.6569 17.6569C16.538 18.7757 15.1126 19.5376 13.5607 19.8463C12.0089 20.155 10.4003 19.9965 8.93853 19.391C7.47672 18.7855 6.22729 17.7602 5.34824 16.4446C4.46919 15.129 4 13.5823 4 12"
                    stroke="#3B4C74"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    fill="none"
                />
            </svg>
            <style>
                {`
                @keyframes rotate {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
                `}
            </style>
        </>
    )
}

export default AILabelNewIcon
